import React, { PureComponent } from 'react'
import utils from './utilities/utils'
import getLink from '../config/urls'

class HeaderScripts extends PureComponent {
  
  render() {
    const { slug } = this.props  

    const service = true
    utils.adobePageLoad(slug, service);

    const baduScript = `var _hmt = _hmt || [];
      (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?2a7cc334cdf90770ccbb1a38d57ea3d1";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();`

    const schemaScript = ` {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Elsevier Author Services",
      "alternateName": "Elsevier Webshop",
      "url": "https://webshop.elsevier.com/",
      "logo": "https://webshop.elsevier.com/images/elsevier.svg",
      "sameAs": [
        "https://www.facebook.com/elsevierauthorservices/",
        "https://www.youtube.com/channel/UCeg3r-A2cTOUNHB1vvKBT9g",
        "https://www.linkedin.com/company/elsevier-authorservices/",
        "https://www.pinterest.com/elsevierauthorservices/"
      ]
    }`;

    const oneTrustScript = 'function OptanonWrapper() { }';
    

    return (      
          <>
            <script
              src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
              type="text/javascript"
              data-domain-script={getLink('cookielaw')}
            />
            <script>{oneTrustScript}</script>
            <script>{baduScript}</script>
            <script src={getLink('adobedtm')} />
            <script type="application/ld+json">
              {schemaScript}
            </script>          
            </>
    )
  }
}


export default HeaderScripts
